import ApiService from '@services/api.service';
import { Notify } from 'quasar';

export const user = {
  state: {
    users: [],
  },
  mutations: {
    setUsers(state, users) {
      state.users = users
    },
    setUser(state, user) {
      // Ajouter ou mettre à jour un utilisateur spécifique
      const index = state.users.findIndex(u => u.id === user.id);
      if (index !== -1) {
        state.users.splice(index, 1, user);
      } else {
        state.users.push(user);
      }
    },
    removeUser(state, userId) {
      // Supprimer un utilisateur du state (soft delete)
      const index = state.users.findIndex(u => u.id === userId);
      if (index !== -1) {
        state.users.splice(index, 1);
      }
    },
  },
  actions: {
    async fetchUsers({ commit }, params = { suspendre: 0, 'deleted_at[exist]': false }) {
      try {
        if(params['deleted_at[exists]'] === undefined) {
          params['deleted_at[exists]'] = 'false';

          // On limite les propriétés retournées pour la liste
          // -> seulement id, name, lastname, civility, antenne
          const requestParams = {
            ...params,
            'properties[id]': true,
            'properties[name]': true,
            'properties[lastname]': true,
            'properties[civility]': true,
            'properties[antenne]': true,
            'properties[suspendre]': true,
            'properties[roles]':true,
          };

          const response = await ApiService.getRequest('users', requestParams);
          commit('setUsers', response.data['hydra:member']);
          return response.data['hydra:member'];
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des utilisateurs:", error);
        // Notify can be added here if needed
        throw error;
      }
    },
    fetchOneUser(context, url) {
      return ApiService.getRequest(url).then(
        response => {
          context.commit('setUser', response.data)
        }
      )
      .catch( error => { console.error(error) } );
    },
    fetchAntenneUsers(context, antenneId) {
      return ApiService.getRequest(`users?antenne=${antenneId}`).then(
        response => {
          context.commit('setUsers', response.data['hydra:member'])
        }
      )
        .catch( error => { console.error(error) } );
    },
    async fethUserlightList(context,  user ){
      return await ApiService.getRequest(`user_light_list/${user}`).then(
        response => {
          context.commit('setUsers', response.data)
        }
      ).catch(error => { console.error(error) });
    },

    async fetchUsersWhoAreReferentHandicap(context){
      try{
        const response = await ApiService.getRequest('users', {
          isReferentHandicap: true,
          'properties[id]': true,
          'properties[name]': true,
          'properties[lastname]': true,
          'proterties[isReferentHandicap]': true,
        });
        const members = response.data['hydra:member'];
        context.commit('setUsers', members);
        return members;
      }catch (e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: "red"
        })
      }
    }
  },
  getters: {
    getUsers(state) {
      return state.users;
    },
    getUser(state) {
      return state.user;
    },
    getUserById: (state) => (id) => {
      return state.users.find(user => user.id === id);
    }
  }
}
